import { useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { PageHead } from "@/components/Motion";
import { Kept, Loading, useApi } from "@/components/Common";
import { media } from "@/lib/api";
import { useSite } from "@/context/SiteContext";

const pin = (on) => L.divIcon({
  className: "",
  html: `<div style="width:22px;height:22px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);background:#C9A24B;border:2px solid #F6EFE0;box-shadow:0 0 ${on ? 18 : 0}px rgba(201,162,75,.9);opacity:${on ? 1 : 0.25};transition:opacity .6s"></div>`,
  iconSize: [22, 22], iconAnchor: [11, 22],
});

export default function Places() {
  const { session } = useSite() || {};
  const { data, loading } = useApi("/public/list/places", [session?.active]);
  const [year, setYear] = useState(2026);
  const items = Array.isArray(data?.items) ? data.items : [];
  return (
    <div data-testid="places-page">
      <PageHead eyebrow="Remember · Family Map" title="Where We've Lived" line="Towns and regions only. Never a home address." />
      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-28">
        {loading ? <Loading /> : items.length ? (
          <>
            <div className="flex flex-col md:flex-row md:items-center gap-4 mb-6">
              <p className="font-display text-4xl text-[#C9A24B] w-28" data-testid="map-year">{year}</p>
              <input type="range" min="1890" max="2026" value={year} onChange={(e) => setYear(Number(e.target.value))} className="flex-1 accent-[#C9A24B]" data-testid="map-year-slider" aria-label="Year" />
            </div>
            <div className="rounded-2xl overflow-hidden border border-[#C9A24B]/40 h-[65vh] min-h-[420px]" data-lenis-prevent data-testid="family-map">
              <MapContainer center={[0, 0]} zoom={2} minZoom={2} scrollWheelZoom className="w-full h-full" worldCopyJump>
                <TileLayer attribution='&copy; OpenStreetMap contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                {items.map((p) => {
                  const on = year >= (p.from || 1890) && year <= (p.to || 2026);
                  return (
                    <Marker key={p.id} position={[p.lat, p.lng]} icon={pin(on)}>
                      <Popup>
                        <div className="w-56">
                          {p.photo_url && <img src={media(p.photo_url)} alt={p.name} className="w-full h-24 object-cover rounded mb-2" />}
                          <p className="font-display text-lg">{p.name}</p>
                          <p className="text-xs text-[#E4C87F]">{p.region} · {p.from}–{p.to}</p>
                          <p className="mt-1 text-xs">{p.note}</p>
                        </div>
                      </Popup>
                    </Marker>
                  );
                })}
              </MapContainer>
            </div>
          </>
        ) : <Kept title="Our places are private" text="Map pins are shared with family only." era="today" />}
      </section>
    </div>
  );
}
